import React, { useState, useEffect } from "react";
import { FaUser, FaUserFriends, FaIdBadge } from "react-icons/fa";
import "./Current.css";
import { FaUser as FaUserIcon } from "react-icons/fa";


  

export default function CurrentAccountForm() {
    const [relation, setRelation] = useState("");
  const [idProof, setIdProof] = useState("");

  const [step, setStep] = useState(1);
  
    // Customer states
    const [customerId, setCustomerId] = useState("");
    const [customerData, setCustomerData] = useState({
      name: "",
      parent: "",
      aadhar: "",
      pan: "",
      mobile: "",
      address: "",
    });
    const [customerLoading, setCustomerLoading] = useState(false);
  
    // Nominee states
    const [nomineeId, setNomineeId] = useState("");
    const [nomineeData, setNomineeData] = useState({
      nomineeName: "",
      dob: "",
      aadhar: "",
      pan: "",
      mobile: "",
      address: "",
    });
    const [nomineeLoading, setNomineeLoading] = useState(false);

  
    // Referral states
    const [referralId, setReferralId] = useState("");
    const [referralName, setReferralName] = useState("");
  
  
    // Mock API fetch for customer
    const fetchCustomer = async () => {
      setCustomerLoading(true);
      return new Promise((resolve) => {
        setTimeout(() => {
          setCustomerLoading(false);
          resolve({
            name: "John Doe",
            parent: "Mr. Doe",
            aadhar: "123412341234",
            pan: "ABCDE1234F",
            mobile: "9876543210",
            address: "123 Main Street",
          });
        }, 1000);
      });
    };
  
    // Mock API fetch for nominee
    const fetchNominee = async () => {
      setNomineeLoading(true);
      return new Promise((resolve) => {
        setTimeout(() => {
          setNomineeLoading(false);
          resolve({
            nomineeName: "Jane Doe",
            dob: "2000-01-01",
            aadhar: "432143214321",
            pan: "XYZAB1234C",
            mobile: "9876501234",
            address: "456 Side Street",
          });
        }, 1000);
      });
    };
  
    // Fetch customer when ID is entered
    useEffect(() => {
      if (customerId) {
        fetchCustomer().then((data) => setCustomerData(data));
      } else {
        setCustomerData({
          name: "",
          parent: "",
          aadhar: "",
          pan: "",
          mobile: "",
          address: "",
        });
      }
    }, [customerId]);
  
    // Fetch nominee when nominee ID is entered
    useEffect(() => {
      if (nomineeId) {
        fetchNominee().then((data) => setNomineeData(data));
      } else {
        setNomineeData({
          nomineeName: "",
          dob: "",
          aadhar: "",
          pan: "",
          mobile: "",
          address: "",
        });
      }
    }, [nomineeId]);
  
    const isNomineeValid = () => {
      const { nomineeName, dob, aadhar, pan, mobile, address } = nomineeData;
      return (
        nomineeId &&
        nomineeName &&
        dob &&
        aadhar &&
        pan &&
        mobile &&
        address &&
        relation &&
        idProof
      );
    };
  
    const resetStep1 = () => setCustomerId("");
    const resetStep2 = () => {
      setNomineeId("");
      setNomineeData({
        nomineeName: "",
        dob: "",
        aadhar: "",
        pan: "",
        mobile: "",
        address: "",
      });
      setRelation("");
      setIdProof("");
    };
    const resetStep3 = () => {
      setReferralId("");
      setReferralName("");
    };
  
    // Customer fields mapped to display like Nominee style
    const customerFields = [
      { label: "Customer ID", key: "customerId", value: customerId, required: true },
      { label: "CUS Name", key: "name", value: customerData.name, required: true },
      { label: "Parent's Name", key: "parent", value: customerData.parent, required: true },
      { label: "Aadhar", key: "aadhar", value: customerData.aadhar, required: true },
      { label: "PAN", key: "pan", value: customerData.pan, required: true },
      { label: "Mobile", key: "mobile", value: customerData.mobile, required: true },
      { label: "Address", key: "address", value: customerData.address, required: true },
    ];
  
  


  const [formData, setFormData] = useState({
    accountType: "CURRENT",
    businessName: "",
    businessType: "",
    scheme: "",
    overdraft: "No",
    overdraftLimit: "",
    cashDepositLimit: "",
    cashWithdrawalLimit: "",
    fundTransferLimit: "",
    operationMode: "",
    openingDate: "",
    ifscCode: "",
    branchName: "",
    accountNumber: "Auto-generated",
    kycStatus: "",
    accountStatus: "",
    internetBanking: "No",
    panOrGst: "",
    registrationNo: "",
    email: "",
    mobile: "",
 
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    alert("Current Account Form Submitted ✅");
    console.log(formData);
  };

  return (
    <div className="Current-container">
      <h2 className="Current-title">Current Account Form</h2>
      <form onSubmit={handleSubmit} className="CA-form">
        
        {/* Account Information */}
        <div className="Current-section">
          <h3>ACCOUNT INFORMATION</h3>
          <div className="Current-grid">
            <div className="Current-row">
              <label>Account Type :</label>
              <input type="text" value="CURRENT" disabled />
            </div>

            <div className="Current-row">
              <label>Business / Firm Name :</label>
              <input
                type="text"
                name="businessName"
                value={formData.businessName}
                onChange={handleChange}
                placeholder="Enter Business Name"
              />
            </div>

            <div className="Current-row">
              <label>Business Type :</label>
              <select name="businessType" value={formData.businessType} onChange={handleChange}>
                <option value="">Select Type</option>
                <option>Proprietorship</option>
                <option>Partnership</option>
                <option>Pvt Ltd</option>
                <option>LLP</option>
              </select>
            </div>

            <div className="Current-row">
              <label>Scheme Name :</label>
              <select name="scheme" value={formData.scheme} onChange={handleChange}>
                <option value="">Select Scheme</option>
                <option>Regular Current</option>
                <option>Premium Current</option>
                <option>Smart Current</option>
              </select>
            </div>

            <div className="Current-row">
              <label>Overdraft Facility :</label>
              <select name="overdraft" value={formData.overdraft} onChange={handleChange}>
                <option>No</option>
                <option>Yes</option>
              </select>
            </div>

            <div className="Current-row">
              <label>Overdraft Limit (₹) :</label>
              <input
                type="number"
                name="overdraftLimit"
                value={formData.overdraftLimit}
                onChange={handleChange}
                placeholder="Enter Overdraft Limit"
              />
            </div>

            <div className="Current-row">
              <label>Cash Deposit Limit (Daily) :</label>
              <input
                type="number"
                name="cashDepositLimit"
                value={formData.cashDepositLimit}
                onChange={handleChange}
                placeholder="Enter Deposit Limit"
              />
            </div>

            <div className="Current-row">
              <label>Cash Withdrawal Limit (Daily) :</label>
              <input
                type="number"
                name="cashWithdrawalLimit"
                value={formData.cashWithdrawalLimit}
                onChange={handleChange}
                placeholder="Enter Withdrawal Limit"
              />
            </div>

            <div className="Current-row">
              <label>Fund Transfer Limit :</label>
              <input
                type="number"
                name="fundTransferLimit"
                value={formData.fundTransferLimit}
                onChange={handleChange}
                placeholder="Enter Transfer Limit"
              />
            </div>

            <div className="Current-row">
              <label>Operation Mode :</label>
              <select name="operationMode" value={formData.operationMode} onChange={handleChange}>
                <option value="">Select Mode</option>
                <option>Single</option>
                <option>Joint</option>
                <option>Authorized Signatory</option>
              </select>
            </div>

            <div className="Current-row">
              <label>Opening Date :</label>
              <input
                type="date"
                name="openingDate"
                value={formData.openingDate}
                onChange={handleChange}
              />
            </div>
          </div>
        </div>

        {/* Banking Details */}
        <div className="Current-section">
          <h3>Banking Details</h3>
          <div className="Current-grid">
            <div className="Current-row">
              <label>Bank IFSC Code :</label>
              <input
                type="text"
                name="ifscCode"
                value={formData.ifscCode}
                onChange={handleChange}
                placeholder="Enter IFSC Code"
              />
            </div>

            <div className="Current-row">
              <label>Branch Name :</label>
              <input
                type="text"
                name="branchName"
                value={formData.branchName}
                onChange={handleChange}
                placeholder="Enter Branch Name"
              />
            </div>

            <div className="Current-row">
              <label>Account Number :</label>
              <input type="text" value="Auto-generated" disabled />
            </div>

            <div className="Current-row">
              <label>KYC Status :</label>
              <select name="kycStatus" value={formData.kycStatus} onChange={handleChange}>
                <option value="">Select Status</option>
                <option>Pending</option>
                <option>Verified</option>
              </select>
            </div>

            <div className="Current-row">
              <label>Account Status :</label>
              <select name="accountStatus" value={formData.accountStatus} onChange={handleChange}>
                <option value="">Select Status</option>
                <option>Active</option>
                <option>Dormant</option>
                <option>Closed</option>
              </select>
            </div>

            <div className="Current-row">
              <label>Enable Internet Banking :</label>
              <select name="internetBanking" value={formData.internetBanking} onChange={handleChange}>
                <option>No</option>
                <option>Yes</option>
              </select>
            </div>
          </div>
        </div>

        {/* Business Identification */}
        <div className="Current-section">
          <h3>Business Identification (KYC)</h3>
          <div className="Current-grid">
            <div className="Current-row">
              <label>PAN / GST Number :</label>
              <input
                type="text"
                name="panOrGst"
                value={formData.panOrGst}
                onChange={handleChange}
                placeholder="Enter PAN / GST No."
              />
            </div>

            <div className="Current-row">
              <label>Business Registration Number :</label>
              <input
                type="text"
                name="registrationNo"
                value={formData.registrationNo}
                onChange={handleChange}
                placeholder="Enter Registration No."
              />
            </div>

            <div className="Current-row">
              <label>Email ID :</label>
              <input
                type="email"
                name="email"
                value={formData.email}
                onChange={handleChange}
                placeholder="Enter Email"
              />
            </div>

            <div className="Current-row">
              <label>Mobile Number :</label>
              <input
                type="text"
                name="mobile"
                value={formData.mobile}
                onChange={handleChange}
                placeholder="Enter Mobile"
              />
            </div>
          </div>
        </div>
   </form>
   
           

           {/* Multi-step Form */}
                 <div className="Currentinteractive-form-container">
                   <h1 className="Currenth1">Customer & Nominee Form</h1>
                   <div className="Currentprogress-bar">
                     <div className="Currentprogress" style={{ width: `${(step / 3) * 100}%` }}></div>
                   </div>
           
                   {/* Step 1: Customer Details */}
                   {step === 1 && (
                     <div className="CurrentNom-card animated-card">
                       <h2><FaUser /> Customer Details</h2>
           
                       {customerFields.map(({ label, key, value, required }) => (
                         <div className="CurrentNom-row-box" key={key}>
                           <div className="CurrentNom-label-cell">
                             {label} {required && <span className="Currentrequired">*</span>}
                           </div>
                           <div className="CurrentNom-value-cell">
                             <input
                               type="text"
                               placeholder={label}
                               value={key === "customerId" ? customerId : value}
                               onChange={(e) =>
                                 key === "customerId"
                                   ? setCustomerId(e.target.value)
                                   : setCustomerData({ ...customerData, [key]: e.target.value })
                               }
                               disabled={key !== "customerId"}
                             />
                           </div>
                         </div>
                       ))}
           
                       {customerLoading && <p className="Currentloading-text">Loading customer data...</p>}
           
                       <div className="Currentstep-buttons">
                         <button
                           className="Currentnext-btn"
                           onClick={() => setStep(2)}
                           disabled={!customerId || customerLoading}
                         >
                           Next: Nominee Details
                         </button>
                         <button className="Currentreset-btn" onClick={resetStep1}>Reset</button>
                       </div>
                     </div>
                   )}
           
                   {/* Step 2: Nominee Details */}
                   {step === 2 && (
                     <div className="CurrentNom-card animated-card">
                       <h2><FaUserFriends /> Nominee Details</h2>
           
                       {nomineeLoading && <p className="Currentloading-text">Loading nominee data...</p>}
           
                       {[
                         { label: "Nominee ID", key: "nomineeId", value: nomineeId, required: true },
                         { label: "Name", key: "nomineeName", value: nomineeData.nomineeName, required: true },
                         { label: "DOB", key: "dob", value: nomineeData.dob, type: "date", required: true },
                         { label: "Aadhar", key: "aadhar", value: nomineeData.aadhar, required: true },
                         { label: "PAN", key: "pan", value: nomineeData.pan, required: true },
                         { label: "Mobile", key: "mobile", value: nomineeData.mobile, required: true },
                         { label: "Address", key: "address", value: nomineeData.address, required: true },
                       ].map(({ label, key, value, type, required }) => (
                         <div className="CurrentNom-row-box" key={key}>
                           <div className="CurrentNom-label-cell">
                             {label} {required && <span className="Currentrequired">*</span>}
                           </div>
                           <div className="CurrentNom-value-cell">
                             <input
                               type={type || "text"}
                               placeholder={label}
                               value={key === "nomineeId" ? nomineeId : value}
                               onChange={(e) =>
                                 key === "nomineeId"
                                   ? setNomineeId(e.target.value)
                                   : setNomineeData({ ...nomineeData, [key]: e.target.value })
                               }
                             />
                           </div>
                         </div>
                       ))}
           
                       <div className="CurrentNom-row-box">
                         <div className="CurrentNom-label-cell">Nominee Relation <span className="Currentrequired">*</span></div>
                         <div className="CurrentNom-value-cell">
                           <select value={relation} onChange={(e) => setRelation(e.target.value)}>
                             <option value="">Select Relation</option>
                             <option value="Father">Father</option>
                             <option value="Mother">Mother</option>
                             <option value="Spouse">Spouse</option>
                             <option value="Son">Son</option>
                             <option value="Daughter">Daughter</option>
                           </select>
                         </div>
                       </div>
           
                       {relation && (
                         <div className="CurrentNom-row-box">
                           <div className="CurrentNom-label-cell">ID Proof <span className="Currentrequired">*</span></div>
                           <div className="CurrentNom-value-cell">
                             <select value={idProof} onChange={(e) => setIdProof(e.target.value)}>
                               <option value="">Select ID Proof</option>
                               <option value="Aadhar">Aadhar</option>
                               <option value="PAN">PAN</option>
                               <option value="VoterID">Voter ID</option>
                             </select>
                           </div>
                         </div>
                       )}
           
                       {idProof && (
                         <div className="CurrentNom-row-box">
                           <div className="CurrentNom-label-cell">Choose File <span className="Currentrequired">*</span></div>
                           <div className="CurrentNom-value-cell">
                             <input type="file" />
                           </div>
                         </div>
                       )}
           
                       <div className="Currentstep-buttons">
                         <button
                           className="Currentnext-btn"
                           onClick={() => setStep(3)}
                           disabled={!isNomineeValid() || nomineeLoading}
                         >
                           Next: Referral Details
                         </button>
                         <button className="Currentprev-btn" onClick={() => setStep(1)}>Back</button>
                         <button className="Currentreset-btn" onClick={resetStep2}>Reset</button>
                       </div>
                     </div>
                   )}
           
                   {/* Step 3: Referral Details */}
                   {step === 3 && (
                     <div className="CurrentRef-card animated-card">
                       <h2><FaIdBadge /> Referral Details</h2>
           
                       <div className="CurrentRef-row-horizontal">
                         <div className="CurrentRef-column">
                           <label><FaIdBadge /> Referral ID <span className="Currentrequired">*</span></label>
                           <input
                             type="text"
                             placeholder="Enter Referral ID"
                             value={referralId}
                             onChange={(e) => setReferralId(e.target.value)}
                           />
                         </div>
                         <div className="CurrentRef-column">
                           <label><FaUser /> Referral Name <span className="Currentrequired">*</span></label>
                           <input
                             type="text"
                             placeholder="Enter Referral Name"
                             value={referralName}
                             onChange={(e) => setReferralName(e.target.value)}
                           />
                         </div>
                       </div>
           
                       <div className="Currentstep-buttons">
                         <button
                           type="button"
                           className="sub"
                           disabled={!referralId || !referralName}
                           onClick={() => alert("Account opened successfully! 🎉")}
                         >
                           Open Current Account
                         </button>
                         <button className="Currentprev-btn" onClick={() => setStep(2)}>Back</button>
                         <button className="Currentgreset-btn" onClick={resetStep3}>Reset</button>
                       </div>
                     </div>
                   )}
                 </div>
   
   
   
   </div>
  );
}
